export default "__VITE_ASSET__f511c759__"